import React from "react";

const LeaveRoomButton = () => {
  const handleRoomDisconnection = () => {
    const siteUrl = window.location.origin;
    window.location.href = siteUrl;
    localStorage.removeItem('startTime')
  };

  return (
    <div className="video_button_container">
      <button className="video_button_end" onClick={handleRoomDisconnection}>
        {window.innerWidth < 768 ? "End" : "Leave Room"}
      </button>
    </div>
  );
};

export default LeaveRoomButton;
